export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ROUTES = {
    EXTRACTOS: BASE_URL + 'extracto/',
    EXTRACTOREGISTRO:  BASE_URL + 'extracto-registro/',
    TIPOSORTEO:  BASE_URL + 'tipo-sorteo/',
};
